import { render, staticRenderFns } from "./PlansHome.vue?vue&type=template&id=ed6bbd82"
import script from "./PlansHome.vue?vue&type=script&lang=js"
export * from "./PlansHome.vue?vue&type=script&lang=js"
import style0 from "./PlansHome.vue?vue&type=style&index=0&id=ed6bbd82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports